export default {
    common: {
        unit: 'USDT',
        day: 'zi',
        week: 'săptămână',
        save: 'Salvați',
        submit: 'Trimite',
        confirmtitle: 'Confirmați operația',
        confirm: 'Confirmare',
        reset: 'Resetare',
        refresh: 'Reîmprospătare',
        copy: 'Copiere',
        copysuccessful: 'Copiat cu succes',
        modify: 'Modificare',
        binding: 'Legare',
        finished: 'Finalizat',
        canceled: 'Anulat',
        cancel: 'Anulare',
        all: 'Tot',
        back: 'Înapoi',
        loading: 'Se încarcă...',
        nomore: 'Toate înregistrările',
        errortxt: 'Încărcare eșuată',
        loosing: 'Eliberați pentru a reîmprospăta...',
        pulling: 'Trageți în jos pentru a reîmprospăta...',
        nodata: 'Nu există înregistrări momentan',
        buy: 'Cumpărare',
        buyup: 'Cumpărare creștere',
        buydown: 'Cumpărare scădere',
        sell: 'Vânzare',
        forserver: 'Contactați serviciul clienți',
        total: 'Total',
        status1: 'În așteptare',
        status2: 'Finalizat',
        status3: 'Respins',
        paytype1: 'TRC20',
        paytype2: 'ERC20',
        paytype3: 'Transfer bancar',
    },
    footer: {
        home: 'Acasă',
        market: 'Piață',
        exchange: 'Schimb',
        options: 'Opțiuni',
        assets: 'Active',
        change: 'Transfer',
        recharge: 'Depunere',
        withdrawal: 'Retragere'
    },
    home: {
        menu1: 'T.O.',
        menu1desc: 'BTC/USDT și altele',
        menu2: 'Depunere rapidă',
        menu3: 'Retragere',
        menu4: 'Serviciu clienți online',
        menu5: 'Schimb instant',
        menu6: 'Împrumut',
        menu7: 'Mining cu blocare',
        menu8: 'Stake',
        menu9: 'Transfer',
        ranktitle: 'Clasament creșteri',
        name: 'Nume',
        price: 'Preț curent',
        risefall: 'Variație',
    },
    register: {
        register: 'Înregistrare',
        login: 'Autentificare',
        email: 'Email',
        phone: 'Telefon',
        accountplaceholder: 'Introduceți contul',
        emailplaceholder: 'Introduceți email-ul',
        phoneplaceholder: 'Introduceți telefonul',
        pwdplaceholder: 'Introduceți parola',
        pwdplaceholder1: 'Parola trebuie să conțină 6-20 caractere alfanumerice',
        agepwdplaceholder: 'Reintroduceți parola',
        agepwdplaceholder1: 'Parolele nu se potrivesc',
        invitecodeplaceholder: 'Introduceți codul de invitație',
        remember: 'Ține-mă minte',
        fotget: 'Am uitat parola'
    },
    market: {
        title: 'Piață',
        all: 'Tot'
    },
    member: {
        reputation: 'Scor reputație',
        identity_authentication: 'Verificare identitate',
        under_review: 'În verificare',
        certified: 'Verificat',
        awaiting_certification: 'În așteptare',
        binding_withdrawal_address: 'Adresă retragere',
        currently_selected_currency: 'Moneda selectată',
        withdrawal_address: 'Adresă retragere',
        sharing_link: 'Link-ul meu de partajare',
        my_promotion_code: 'Codul meu promoțional',
        promotion_code: 'Cod promoțional',
        system_message: 'Mesaje sistem',
        night_mode: 'Mod noapte',
        security_center: 'Centru securitate',
        seted: 'Setat',
        noset: 'Nesetat',
        login_password: 'Parolă autentificare',
        transaction_password: 'Parolă retragere',
        app_download: 'Descărcare aplicație',
        log_out: 'Deconectare',
        aboutus: 'Despre noi'
    },
    identity: {
        title: 'Verificare identitate',
        name: 'Nume',
        nameplaceholder: 'Introduceți numele real',
        uploader: 'Încărcați poza CI',
        tip1: 'Încărcați fața CI',
        tip2: 'Încărcați spatele CI'
    },
    address: {
        title: 'Adresă retragere',
        bType: 'Moneda selectată',
        address: 'Adresă retragere',
        addressplaceholder: 'Introduceți adresa de retragere',
    },
    security: {
        title: 'Centru securitate',
        modifypwd: 'Parolă autentificare',
        resetlegalpwd: 'Parolă tranzacție',
        loginpwd: 'Parolă nouă',
        pwdage: 'Confirmare parolă',
        loginpwdplaceholder: 'Introduceți parola curentă',
        loginnewpwdplaceholder: 'Introduceți noua parolă',
        moneypwd: 'Introduceți parola de tranzacție',
        pwdageplaceholder: 'Reintroduceți parola'
    },
    trade: {
        title: 'Schimb',
        price: 'Preț',
        num: 'Cantitate',
        entrust: 'Ordine curente',
        clinch: 'Tranzacții efectuate',
        used: 'Disponibil',
        buyed: 'Poate cumpăra',
        amount: 'Sumă tranzacție',
        limitprice: 'Limită preț',
        marketprice: 'Preț piață',
        forprice: 'Tranzacționare la cel mai bun preț curent',
        errorMoney: 'Sold insuficient',
        priceerror: 'Introduceți prețul ordinului',
        numerror: 'Introduceți cantitatea ordinului',
        moneyerror: 'Introduceți suma ordinului',
    },
    assets: {
        allconvert: 'Total active convertite',
        usenum: 'Disponibil',
        freeze: 'Blocat',
        convert: 'Convertit',
        tab1: 'Active',
        tab11: 'Total active convertite',
        tab12: 'Opțiuni convertite',
        tab13: 'Fonduri convertite',
        tab14: 'Cantitativ convertit',
        tab2: 'Opțiuni',
        tab21: 'Cont opțiuni',
        tab3: 'Fonduri',
        tab31: 'Cont fonduri',
        tab4: 'Cantitativ',
        tab41: 'Cont cantitativ',
        tbhead1: 'Înregistrări financiare',
        tbhead2: 'Înregistrări retrageri',
        tbhead3: 'Înregistrări depuneri',
        tbhead4: 'Înregistrări transferuri',
        rcdnum: 'Cantitate',
        rcd: 'Înregistrare',
        rcdtime: 'Timp',
        rcdstatus: 'Stare',
        rcddesc: 'Notă',
        rcdaddress: 'Adresă depunere'
    },
    change: {
        title: 'Transfer',
        from: 'De la {name}',
        to: 'Către {name}',
        frmtitle: 'Cantitate transfer',
        inputplaceholder: 'Introduceți cantitatea de transferat',
        btntxt: 'Transfer'
    },
    recharge: {
        title: 'Depunere',
        bType: 'Moneda curentă',
        address: 'Adresă depunere',
        token: 'Dovadă plată',
        tokenplaceholder: 'Încărcați dovada plății',
        num: 'Cantitate depunere',
        numplaceholder: 'Introduceți cantitatea',
        btn: 'Trimite pentru verificare',
        bankname: 'Nume bancă',
        bankno: 'Număr bancă',
        accountname: 'Nume cont beneficiar',
        bankaddress: 'Adresă bancă',
        bankcode: 'Cod transfer bancar',
        companyaddress: 'Adresă companie'
    },
    withdrawal: {
        title: 'Retragere',
        frmtitle1: 'Cantitate',
        frmplaceholder1: 'Cantitatea de retragere între {min} - {max}',
        frmtitle2: 'Parolă tranzacție',
        frmplaceholder2: 'Introduceți parola de tranzacție',
        getnum: 'Cantitate primită',
        fee: 'Comision',
        btn: 'Retragere'
    },
    exchangeb: {
        title: 'Schimb',
        account: 'Cont',
        btn: 'Schimb',
        numerror: 'Introduceți cantitatea de schimb'
    },
    option: {
        title: 'Opțiuni',
        typetitle: 'Contract secunde',
        listtitle: 'Poziții',
        kline: 'Grafic K',
        high: 'Maxim',
        low: 'Minim',
        nums: 'Volum 24H',
        time: 'Timp',
        transaction: 'Mod tranzacționare',
        quantity: 'Cantitate deschidere',
        quantityerror: 'Introduceți cantitatea de deschidere',
        times: 'Timp deschidere',
        times1: 'Ora decontării',
        account: 'Sold cont',
        buyup: 'Cumpărare creștere',
        buydown: 'Cumpărare scădere',
        tab1: 'Listă poziții',
        tab2: 'Istoric ordine',
        num: 'Cantitate',
        price1: 'Preț cumpărare',
        price2: 'Preț executare',
        profitandloss: 'Profit/Pierdere estimat',
        profitandloss1: 'Profit/Pierdere',
        countdown: 'Numărătoare inversă',
        waitfinish: 'În așteptare decontare',
        finishing: 'În decontare...',
        finished: 'Decontat',
        order_price: 'Preț curent',
        order_cycle: 'Ciclu',
        order_type: 'Tip',
        order_money: 'Sumă',
        order_time: 'Deschidere',
        order_get: 'Profit',
        order_btn: 'Continuă ordinul'
    },
    tradelst: {
        title: 'Ordinele mele',
        tab1: 'Ordine',
        tab2: 'Finalizate',
        tab3: 'Anulate',
        usdtnum: ''
    },
    loans: {
        title: 'Împrumut',
        order_tab: 'Ordine împrumut',
        pro_tab: 'Produse împrumut',
        Institution: 'Instituție creditare',
        Amount: 'Sumă',
        DailyInterest: 'Dobândă zilnică',
        RepaymentPeriod: 'Perioadă rambursare',
        Application: 'Aplicare împrumut',
        orderno: 'Număr ordin',
        AllInterest: 'Dobândă totală',
        RepaymentDate: 'Data rambursării',
        RepaymentMethod: 'Metodă rambursare',
        Onetime: 'O singură dată',
        Expected_loan_amount: 'Sumă împrumut dorită',
        Expected_loan_amounterror: 'Suma împrumutului între {min} - {max}',
        imgplaceholdr: 'Credit (asigurați-vă că imaginile sunt clare)',
        icon1: 'Încărcați fața documentului',
        icon2: 'Încărcați spatele documentului',
        icon3: 'Încărcați selfie cu document',
        status1: 'În aplicare',
        status2: 'Aprobat',
        status3: 'Respins',
    },
    lockming: {
        title: 'Mining cu blocare',
        order_tab: 'Ordine mining',
        pro_tab: 'Piață mining',
        locknum: 'Cantitate minimă blocare',
        getforday: 'Randament/zile',
        days: 'Zile',
        estimation: 'Profit estimat',
        real: 'Profit realizat',
        balance: 'Sold portofel',
        nums: 'Cantitate blocare',
        tolockming: 'Blocare',
        stime: 'Timp start',
        etime: 'Timp final',
    },
    transfer: {
        title: 'Transfer cont',
        searchtxt: 'Introduceți contul destinatar',
        ReceivingAccount: 'Informații cont beneficiar',
        toaccount: 'Cont',
        confirmtxt: 'Confirmați contul beneficiar',
        confirmedtxt: 'Cont beneficiar confirmat',
        numtxt: 'Cantitate transfer',
        numerror: 'Introduceți cantitatea de transfer',
        fee: 'Fără comision pentru transfer intern',
        ArrivalTime: 'Timp sosire',
        Immediately: 'Imediat',
        realnum: 'Cantitate primită efectiv',
        btn: 'Confirmare transfer',
        transfering: 'În transfer',
        orderNo: 'Număr ordin',
        stime: 'Timp transfer',
        etime: 'Timp sosire',
        receiving: 'Cont beneficiar',
        type: 'Monedă',
        num: 'Cantitate transfer',
        arrivalnum: 'Cantitate primită'
    },
    staking: {
        title: 'Stake',
        record: 'Înregistrări',
        getforyear: 'APY de referință',
        time: 'Perioadă investiție',
        snum: 'Investiție minimă',
        snumerror: 'Introduceți suma minimă',
        snumerror1: 'Suma minimă nu poate fi sub {num}',
        join: 'Participă acum',
        opentime: 'Timp deschidere',
        money: 'Sumă investită',
        days: 'Perioadă',
        recordget: 'APY',
        gets: 'Profit',
        stime: 'Data start',
        etiem: 'Data final',
        redeemStaking: 'Anulare',
        status0: 'În stake',
        status1: 'Ordin finalizat',
        status2: 'Ordin răscumpărat',
    },
    bank: {
        title: 'Legare card bancar',
        bankName: 'Nume bancă',
        bankNameError: 'Introduceți numele băncii',
        usrName: 'Titular card',
        usrNameError: 'Introduceți titularul cardului',
        cardCode: 'Număr card bancar',
        cardCodeError: 'Introduceți numărul cardului',
        towallet: 'Retragere în portofel',
        tobank: 'Retragere în card bancar',
        sendcode: 'Trimite cod verificare',
        sended: 'Retrimitere în {num} secunde',
        verify_code: 'Introduceți codul de verificare email'
    },
    other:{
            welcome: 'Bun venit la {name}',
    homeaboutustitle: 'Platforma globală lider de tranzacționare all-in-one a activelor digitale',
    homeaboutustitle1: 'Garanție de securitate',
    homeaboutusdesc1: 'Colaborare cu instituții de securitate de top pentru a asigura tranzacții sigure și eficiente',
    homeaboutustitle2: 'Serviciu clienți non-stop',
    homeaboutusdesc2: 'Asistență online 24/7, gata să răspundă nevoilor dumneavoastră',
    homeaboutustitle3: 'Acoperire globală',
    homeaboutusdesc3: 'Comunitate internațională acoperind 205 țări/regiuni, suport pentru 11 limbi, 19 comunități naționale/regionale, 5 milioane de utilizatori înregistrați',
    totrade: 'Începe tranzacționarea',
    toregister: 'Începeți călătoria în lumea monedelor digitale',
    yingli: 'Profitul de astăzi',
    kuisun: 'Pierderea de astăzi',
    agree: 'Am citit și sunt de acord',
    useragreement: 'Acordul utilizatorului',
    account: 'Cont',
    pwd: 'Parolă',
    toregister1: 'Nu sunt înregistrat',
    loginbtn: 'Autentificare',
    registerbtn: 'Înregistrează-te acum',
    tologin: 'Ai deja cont? Mergi la înregistrare',
    allrevenue: 'Venit total',
    stakingcount: 'Comandă staking',
    stakingamount: 'Sumă staking',
    todayincome: 'Estimare pentru astăzi'

    }
}
